import { useEffect } from "react";
import BrancoAnim from "../InfoPages/PageContent/BrancoAnim";
import Footer from "../InfoPages/PageContent/Footer";
import SampleProperties from "./SampleProperties";
import VideoPlayer from "../InfoPages/PageContent/VideoPlayer";
import PagesPart from "../InfoPages/PageContent/PagesPart";
import Marquee from "../InfoPages/PageContent/Marquee";
import ExplorePair from "../InfoPages/PageContent/ExplorePair";

function SearchInput({ title, text, page }) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div className="content-ctnr">
      <VideoPlayer full />
      <SampleProperties />
      <BrancoAnim page={page} text={text} />
      <Marquee {...{ page, text }} />
      <ExplorePair {...{ page, text }} />
      <PagesPart />
      <br />
      <br />
      <br />
      <Footer page="search" text={text} />
    </div>
  );
}

export default SearchInput;
